/* eslint-env browser */

(function (window) {
    'use strict';

    var SW_TIMEOUT_MS = 8000;

    function apiBase() {
        return (window.SiwaApp && window.SiwaApp.apiBase) || (window.location.origin + '/siwa-api');
    }

    function swUrl() {
        return apiBase() + '/push/sw.js';
    }

    function urlBase64ToUint8Array(base64String) {
        var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
        var raw = window.atob(base64);
        var output = new Uint8Array(raw.length);
        var i;
        for (i = 0; i < raw.length; i += 1) {
            output[i] = raw.charCodeAt(i);
        }
        return output;
    }

    function supportsPush() {
        return (
            typeof window !== 'undefined' &&
            'serviceWorker' in navigator &&
            'PushManager' in window &&
            'Notification' in window
        );
    }

    function getBanner(root) {
        if (!root) {
            return null;
        }
        return root.querySelector('[data-siwa-push-root]');
    }

    function setBannerMessage(banner, message, tone) {
        if (!banner) {
            return;
        }
        var el = banner.querySelector('[data-siwa-push-message]');
        if (!el) {
            return;
        }
        if (!message) {
            el.hidden = true;
            el.textContent = '';
            el.className = 'siwa-push-banner__message';
            return;
        }
        el.hidden = false;
        el.textContent = message;
        el.className = 'siwa-push-banner__message siwa-push-banner__message--' + (tone || 'info');
    }

    function setBannerState(banner, state) {
        if (!banner) {
            return;
        }
        var enableWrap = banner.querySelector('[data-siwa-push-enable-wrap]');
        var activeWrap = banner.querySelector('[data-siwa-push-active-wrap]');
        var deniedEl = banner.querySelector('[data-siwa-push-denied]');

        banner.hidden = !state.visible;
        if (enableWrap) {
            enableWrap.hidden = state.mode !== 'enable';
        }
        if (activeWrap) {
            activeWrap.hidden = state.mode !== 'active';
        }
        if (deniedEl) {
            deniedEl.hidden = state.mode !== 'denied';
        }
    }

    function refreshBanner(root) {
        var banner = getBanner(root);
        if (!banner || !supportsPush()) {
            if (banner) {
                banner.hidden = true;
            }
            return Promise.resolve();

        }

        return window.SiwaApp.apiFetch('/members/me/push/status')
            .then(function (status) {
                if (!status || !status.available) {
                    banner.hidden = true;
                    return;
                }

                banner.hidden = false;
                if (Notification.permission === 'denied') {
                    setBannerState(banner, { visible: true, mode: 'denied' });
                    return;
                }
                if (status.subscribed && Notification.permission === 'granted') {
                    setBannerState(banner, { visible: true, mode: 'active' });
                    return;
                }
                setBannerState(banner, { visible: true, mode: 'enable' });
            })
            .catch(function () {
                banner.hidden = true;
            });
    }

    function waitForServiceWorker(timeoutMs) {
        return Promise.race([
            navigator.serviceWorker.ready,
            new Promise(function (_resolve, reject) {
                window.setTimeout(function () {
                    reject(new Error('Service worker non registrato. Ricarica la pagina e riprova.'));
                }, timeoutMs || SW_TIMEOUT_MS);
            })
        ]);
    }

    function findPushRegistration() {
        return navigator.serviceWorker.getRegistrations().then(function (registrations) {
            var i;
            for (i = 0; i < registrations.length; i += 1) {
                if (registrations[i].active && registrations[i].active.scriptURL.indexOf('/push/sw.js') !== -1) {
                    return registrations[i];
                }
            }
            return null;
        });
    }

    function registerServiceWorker() {
        return fetch(swUrl(), { method: 'GET', cache: 'no-store' }).then(function (res) {
            if (!res.ok) {
                throw new Error('Service worker non raggiungibile (' + res.status + ')');
            }
            return navigator.serviceWorker.register(swUrl(), { scope: '/' });
        });
    }

    function getOrRegisterServiceWorker() {
        return findPushRegistration().then(function (existing) {
            if (existing) {
                return existing;
            }
            return registerServiceWorker();
        });
    }

    function fetchVapidKey() {
        return fetch(apiBase() + '/push/vapid-public-key')
            .then(function (res) {
                if (!res.ok) {
                    throw new Error('Push non configurato sul server');
                }
                return res.json();
            })
            .then(function (data) {
                return data.public_key;
            });
    }

    function saveSubscription(subscription) {
        var json = subscription.toJSON();
        return window.SiwaApp.apiFetch('/members/me/push/subscribe', {
            method: 'POST',
            body: {
                endpoint: json.endpoint,
                keys: json.keys
            }
        });
    }

    function clearServerSubscriptions() {
        return window.SiwaApp.apiFetch('/members/me/push/unsubscribe-all', {
            method: 'DELETE'
        });
    }

    function ensureSubscription() {
        return getOrRegisterServiceWorker().then(function (registration) {
            return fetchVapidKey().then(function (publicKey) {
                return registration.pushManager.getSubscription().then(function (existing) {
                    if (existing) {
                        return saveSubscription(existing).then(function () {
                            return existing;
                        });
                    }
                    return registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: urlBase64ToUint8Array(publicKey)
                    }).then(function (subscription) {
                        return saveSubscription(subscription).then(function () {
                            return subscription;
                        });
                    });
                });
            });
        });
    }

    function enablePush(root) {
        var banner = getBanner(root);
        var button = banner && banner.querySelector('[data-siwa-push-enable]');
        setBannerMessage(banner, 'Attivazione in corso…', 'info');
        if (button) {
            button.disabled = true;
        }

        return Notification.requestPermission()
            .then(function (permission) {
                if (permission !== 'granted') {
                    throw new Error('Permesso notifiche negato dal browser');
                }
                return ensureSubscription();
            })
            .then(function () {
                setBannerMessage(banner, 'Notifiche attivate.', 'success');
                return refreshBanner(root);
            })
            .catch(function (err) {
                setBannerMessage(
                    banner,
                    (err && err.message) || 'Impossibile attivare le notifiche',
                    'error'
                );
                return refreshBanner(root);
            })
            .finally(function () {
                if (button) {
                    button.disabled = false;
                }
            });
    }

    function disablePush(root) {
        var banner = getBanner(root);
        var button = banner && banner.querySelector('[data-siwa-push-disable]');
        setBannerMessage(banner, 'Disattivazione in corso…', 'info');
        if (button) {
            button.disabled = true;
        }

        return findPushRegistration()
            .then(function (registration) {
                var localUnsub = Promise.resolve();
                if (registration) {
                    localUnsub = registration.pushManager.getSubscription().then(function (subscription) {
                        if (subscription) {
                            return subscription.unsubscribe();
                        }
                        return null;
                    });
                }
                return localUnsub.then(function () {
                    return clearServerSubscriptions();
                });
            })
            .then(function () {
                setBannerMessage(banner, 'Notifiche disattivate.', 'success');
                return refreshBanner(root);
            })
            .catch(function (err) {
                setBannerMessage(
                    banner,
                    (err && err.message) || 'Impossibile disattivare le notifiche',
                    'error'
                );
                return refreshBanner(root);
            })
            .finally(function () {
                if (button) {
                    button.disabled = false;
                }
            });
    }

    function bindBanner(root) {
        var banner = getBanner(root);
        if (!banner || banner.getAttribute('data-siwa-push-bound') === '1') {
            return;
        }
        banner.setAttribute('data-siwa-push-bound', '1');

        var enableBtn = banner.querySelector('[data-siwa-push-enable]');
        var disableBtn = banner.querySelector('[data-siwa-push-disable]');

        if (enableBtn) {
            enableBtn.addEventListener('click', function (event) {
                event.preventDefault();
                enablePush(root);
            });
        }
        if (disableBtn) {
            disableBtn.addEventListener('click', function (event) {
                event.preventDefault();
                disablePush(root);
            });
        }
    }

    function init(root) {
        if (!root || !supportsPush() || !window.SiwaApp) {
            return Promise.resolve();
        }

        bindBanner(root);
        return refreshBanner(root).then(function () {
            if (Notification.permission !== 'granted') {
                return null;
            }
            return ensureSubscription()
                .then(function () {
                    return refreshBanner(root);
                })
                .catch(function (err) {
                    var banner = getBanner(root);
                    setBannerMessage(
                        banner,
                        (err && err.message) || 'Registrazione push non riuscita',
                        'error'
                    );
                    return refreshBanner(root);
                });
        });
    }

    window.SiwaPush = {
        init: init,
        supportsPush: supportsPush,
        waitForServiceWorker: waitForServiceWorker
    };
})(window);
